/**
 * Whether a blocking modal/popup is currently shown, in which case page-level
 * shortcuts (N/P navigation and the action keys) must be suppressed and the
 * vsn-navigation Ctrl/Cmd+K search must be prevented from opening. Covers both
 * the legacy `.pop-up` dialogs and the newer ga-modal shell (Review/Reject/etc.),
 * which renders `.ga-modal__container` instead of carrying the `pop-up` class.
 *
 * Kept in its own side-effect-free module so DOM-only consumers (e.g.
 * VsnNavigation) don't have to pull in keyPressHandler's lodash/redux-store deps.
 * @returns {boolean}
 */
export function isOverlayVisible() {
    return document.getElementsByClassName("pop-up").length > 0
        || document.getElementsByClassName("ga-modal__container").length > 0;
}
